import React from 'react'

const Dash = (props) => {
    return (
        <>
            <svg width="48" height="5" viewBox="0 0 48 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.0090332" y="0.895996" width="47.9039" height="3.33473" fill={props.theme === "light" ? 'black' : 'white'} />
            </svg>
        </>
    )
}

export default Dash